module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "leave-game-widget"
    }
  }, [_c('div', {
    staticClass: "edit-container"
  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('h1', [_vm._v("Are you sure you want to leave this Game Project?")]), _vm._v(" "), (_vm.members.length === 1) ? [_c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v("You're the only member on this project. If you leave, the Game Project and all content created by it will be Deleted.")])] : _vm._e(), _vm._v(" "), (_vm.isOwner && _vm.members.length > 1) ? [_c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v("You're the owner of this project so you will have to choose another member to take that responsibility.")]), _vm._v(" "), _c('label', [_c('span', [_vm._v("New Owner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOwnerId),
      expression: "newOwnerId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newOwnerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.members), function(member) {
    return (member.id !== _vm.myId) ? _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(member.alias))]) : _vm._e()
  }))])] : _vm._e(), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('span', [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelLeaving($event)
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), (_vm.members.length > 1) ? _c('span', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveProject($event)
      }
    }
  }, [_vm._v("Yes, leave Project")])]) : _vm._e(), _vm._v(" "), (_vm.members.length === 1) ? _c('span', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveProject($event)
      }
    }
  }, [_vm._v("Yes, Delete Project")])]) : _vm._e()])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79237552!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/Widgets/LeaveGame.vue
// module id = 893
// module chunks = 2